import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { ConfigService } from '../../services/config/config.service';

@Component({
  selector: 'app-header-message',
  standalone: true,
  imports: [
	MaterialModule
  ],
  templateUrl: './header-message.component.html',
  styleUrl: './header-message.component.scss'
})
export class HeaderMessageComponent implements OnInit {

	headerMessage: string = null;

	constructor(
		private configService: ConfigService
	) {	}

	ngOnInit(): void {
		this.headerMessage = this.configService.getConfig()?.['messageHeader'] ?? null;
	}

	close(): void {
		this.headerMessage = null;
	}

}
